module.exports = __webpack_public_path__ + "img/----thefraternity-white-text-only-powered.6893b87d.png";